<template>
  <div id="app">
    <div class="top">
      <div class="top_icon" style="color: #ffffff;" @click="showNav">
        <template v-if="show">
          <i class="el-icon-close"></i>
        </template>
        <template v-else>
          <i class="el-icon-s-fold"></i>
        </template>
      </div>
      <div class="top_img">
        <img src="@/assets/img/标志中英文反白.png">
      </div>

      <div class="top_nav" id="nav"  v-if=isShowHead>
        <ul class="ul">
          <li class="li dropdown" v-for="(item, index) in navArr1" :key="item.go">
            
            <div :href="item.go" :class="{'color': item.checked}" @click="aaaa(index)">{{ item.name }}
              <div class="dropdown-content">
                <div class="dropdown-menu" v-for="(v, i) in item.data" :key="i">
                  <div class="menuItem" @click.stop="bbbb(index,i)">{{ v.name }}</div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
       <span style="line-height: 50px;" v-if=isShowHead><a style=" font-weight:bolder;color: #ffffff;">中文</a >|<a @click="goPage(languageValue)">English</a ></span>

    </div>
    <keep-alive>
      <router-view @fatherRedirect="redirectNav" @hideHead="hideHead"  v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view @fatherRedirect="redirectNav"  @hideHead="hideHead" v-if="!$route.meta.keepAlive" />
    <!-- 使用返回顶部 组件 -->
    <retuen transitionName="fade" :customStyle="myBackToTopStyle" :visibilityHeight="100" :backPosition="0"></retuen>
    <div class="appFoot">
      <div class="w flex-row justify-between ">
        <div class="foot-content flex-row justify-between">
          <div class="code">
            <img src="./assets/img/code.jpg" style="width: 100%;height: 100%;" alt="">
          </div>
          <div class="flex-column justify-between" style="margin-left: 30px;">
            <div>凡己科技（苏州）有限公司</div>
            <div>
              <p>地址：苏州工业园区东富路48号E幢</p>
              <p>电话：+86-512-6767 8902</p>
              <p>邮箱：fjmarketing@fjctrl.com</p>
              <!-- <p>邮箱：sales@fjctrl.com</p> -->
            </div>
          </div>
        </div>
        <div class="flex-row">
          <img src="./assets/img/tel.png" style="width: 20px;height: 20px;margin-right: 5px;" alt="">
          <div class="">
            <p>7*24 全天服务热线 </p>
            <p style="margin-top: 10px;">400-873-0588</p>
          </div>
        </div>
        <div style="width: 100px;">
          <div class="text-center" style="color: #fff;">服务网点</div>
          <div style="margin-top: 10px;">
            <div class="flex-row justify-between">
              <p>上海</p>
              <p>合肥</p>
            </div>
            <div class="flex-row justify-between">
              <p>重庆</p>
              <p>肇庆</p>
            </div>
            <div class="flex-row justify-between">
              <p>北京</p>
              <p>徐州</p>
            </div>
          </div>
        </div>
      </div>
      <p class="text-center flex-row align-center justify-center">
        <img src="./assets/img/fdg.png" style="width: 25px;height: 25px;margin-right: 5px;" alt="">
        <a href="https://beian.miit.gov.cn/"><font style="color: #fff;">苏ICP备17058216号</font></a> &nbsp; &nbsp; &nbsp;  <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32059002001848"><font style="color: #fff;">苏公网安备32059002001848号</font></a>
      </p>
    </div>
    <!-- <div class="mappFoot">
      <img src="./assets/img/fdg.png" alt="" style="width: 30px;height: 30px;margin-right: 10px;">
    苏ICP备 17058126号-4  苏公网安备32059002001848号
    </div> -->
  </div>
</template>

<script>
// 引入返回顶部 组件
import retuen from '@/components/return.vue'
export default {
  name: 'App',
  data() {
    return {
      show: false,
      isShowHead:true,
      navArr1: [{
        checked:true,
        name: '首页',
        go: 'index'
      },
      {
        checked:false,
        name: '产品中心',
        go: 'products'
      },
      {
        checked:false,
        name: '解决方案',
        go: 'scheme'
      },
      {
        checked:false,
        name: '成功案例',
        go: 'cases'
      },
      {
        checked:false,
        name: '新闻动态',
        go: 'news'
      },
      {
        checked:false,
        name: '关于我们',
        go: 'about',
        data: [
          {
            name: '关于我们',
            go: 'about',
          },
          {
            name: '发展历程',
            go: 'milestone',
          },
          {
            name: '荣誉资质',
            go: 'honor',
          }
        ]
      },
      {
        checked:false,
        name: '联系我们',
        go: 'contact '
      },
      // {
      //   checked:false,
      //   name: '中文',
      //   go: 'index'
      // },
      // {
      //   checked:false,
      //   name: 'English',
      //   // go: '/'
      // }
      ],
      // 按钮的样式
      myBackToTopStyle: {
        'right': '100px',
        'bottom': '150px',
        'width': '40px',
        'height': '40px',
        'border-radius': '20px',
        'line-height': '40px',
        'background': '#fff'
      },
      languageValue:"en",
      languageOptions:[{
          value: 'zh',
          label: '中文'
      },{
          value: 'en',
          label: 'English'
      }]
    }
  },
  // 声明 组件
  components: {
    retuen
  },
  methods: {
    bbbb(index,i) {
      this.navArr1.map((v,i) => {
        v.checked = i == index ? true : false;
        return v;
      })
      let name = this.navArr1[index].data[i].go;
      console.log('this.navArr1[index].data[i]',name);
      this.$router.push({name})
      if(this.show){
        this.showNav();
      }
    },
    aaaa(index) {
      console.log('aaaaaaaa');
      this.navArr1.map((v,i) => {
        v.checked = i == index ? true : false;
        return v;
      })
      let name = this.navArr1[index].go;
      console.log('namenamename',name);
      this.$router.push({name})
      // debugger
      if(this.show&&(this.navArr1[index].data==null||this.navArr1[index].data.length<=0)){
        this.showNav();
      }
      
    },
    // 创建一个方法，来控制导航栏的显示和隐藏
    showNav: function () {
      // 获取id为nav赋值给 nav
      const nav = document.getElementById('nav');
      // 判断show 为false，给导航栏样式 隐藏，然后返回 show 为 true
      if (this.show == false) {
        nav.style.display = "block";
        this.show = true
      } else {
        // show 为 true 就给导航栏样式 显示
        nav.style.display = "none";
        this.show = false
      }
    },
    redirectNav(url){
      debugger
      this.navArr1.forEach(element => {
        if(url==element.go){
          element.checked=true;
        }
        else{
          element.checked=false; 
        }
        
      });
    },
    goPage(languageValue){
      debugger
       if(languageValue=='en'){
        window.location.href = "http://www.fjctrl.com/en/#/"
        }
        else{
          window.location.href = "http://www.fjctrl.com/#/"
        }                           
      },
    hideHead(){
      this.isShowHead=false;
    }
  },
}
</script>

<style scoped lang="scss">
body {
  margin: 0;
  padding: 0;
  max-width: 100%;
  background-color: #fff;
  background-size: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: auto;
}

.top {
  position: fixed;
  width: 100%;
  display: flex;
  text-align: left;
  padding: 10px;
  background-color: #0A7846;
  opacity: 0.8;
  color: #d2d0d0;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  z-index: 99;
}

.top_img {
  width: 20%;
  height: 50px;
  line-height: 50px;
  /* margin-left: 50px; */
}

.top_img img {
  width: 200px;
  /* margin-left: 50px; */
}

.top_nav {
  /* width: 60%; */
  line-height: 30px;
  /* flex: 1; */
  text-align: center;
}

.ul {
  padding: 0;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
  
}
.li {
  margin-left: 20px;
  margin-right: 20px;
  /* 去小数点 */
  list-style: none;
  width: 80px;
  transition: 0.2s all linear;
}

.li a {
  color: #fff;
  text-decoration: none;
}
.color {
  color: #ffffff;
  font-weight: bolder;
}
.li a:hover {
  width: 80px;
  color: #0A7846;
  /* border-bottom: 1px solid #660000; */
}

.appFoot {
  width: 100%;
  height: auto;
  background-color: #0A7846;
  padding: 30px 0;
}

.appFoot_left,
.appFoot_right {
  width: 30%;
  margin: 30px;

}

.appFoot_left {
  margin-left: 20%;
}

.appFoot_right {
  margin-right: 20%;
}

.appFoot a {
  color: black;
  text-decoration: none;
}

.appFoot h5 {
  padding: 10px;
}

.appFoot h6 {
  width: 100%;
  position: absolute;
  text-align: center;
  color: black;
  margin-top: 500px;
}

.foot-content {
  color: #fff;
}

.appFoot p {
  font-size: 14px;
  color: #fff;
}

.code {
  width: 100px;
  height: 100px;
  background-color: #2c3e50;
}

.mappFoot {
  display: none;
  background-color: #0A7846;
  padding: 30px;
}

/* 窗口小于1800 */
@media only screen and (max-width: 1800px) {}

/* 窗口小于1024 */
@media only screen and (max-width: 1024px) {
  #app {
    max-width: 100%;
    height: auto;
    margin: 0;
    padding: 0;
  }

  .top {
    display: flex;
    text-align: left;
    padding: 20px;
  }

  .top_img {
    height: 40px;
    margin-left: 50px;
    text-align: center;
  }

  .top_nav {
    line-height: 30px;
    flex: 1;
    text-align: center;
  }

  ul {
    padding: 0;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
  }

  .li {
    margin-left: 10px;
    margin-right: 10px;
    font-size: 1.2rem;
    font-weight: 600;
    width: 80px;
    transition: 0.2s all linear;
  }

  .li a {
    color: black;
    text-decoration: none;
  }

  .li:hover {
    width: 100%;
    // background: coral;
  }


  .appFoot {
    width: 100%;
    height: auto;
    margin: 0 auto;
  }

  .appFoot_left,
  .appFoot_right {
    width: 50%;
    margin: 0;
    padding: 0;
  }

  .appFoot a {
    color: black;
    text-decoration: none;
  }

  .appFoot h5 {
    font-size: 1rem;
    padding: 10px;
  }

  .appFoot h6 {
    width: 100%;
    font-size: 1rem;
    position: absolute;
    text-align: center;
    color: black;
    margin-top: 350px;
  }
}

@media only screen and (min-width: 700px) {
  .top_icon {
    display: none;
  }
}

/* 窗口小于768 */
@media only screen and (max-width: 768px) {
  #app {
    max-width: 100%;
    height: auto;
    margin: 0;
    padding: 0;
  }

  .top {
    display: flex;
    text-align: left;
    padding: 20px;
  }

  .top_img {
    height: 40px;
    margin-left: 50px;
    text-align: center;
  }

  .top_nav {
    line-height: 30px;
    flex: 1;
    text-align: center;
  }

  ul {
    padding: 0;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
  }

  .li {
    margin-left: 20px;
    margin-right: 20px;
    font-size: 1.2rem;
    font-weight: 600;
    width: 80px;
    transition: 0.2s all linear;
  }

  .li a {
    color: black;
    text-decoration: none;
  }

  .li:hover {
    width: 100%;
    // background: coral;
  }


  .appFoot {
    width: 100%;
    height: auto;
    margin: 0 auto;
  }

  .appFoot_left,
  .appFoot_right {
    width: 50%;
    margin: 0;
    padding: 0;
  }

  .appFoot a {
    color: black;
    text-decoration: none;
  }

  .appFoot h5 {
    font-size: 1rem;
    padding: 10px;
  }

  .appFoot h6 {
    width: 100%;
    font-size: 1rem;
    position: absolute;
    text-align: center;
    color: black;
    margin-top: 350px;
  }
}

/* 窗口小于480 */
@media only screen and (max-width: 480px) {
  #app {
    max-width: 480px;
    height: auto;
    margin: 0;
    padding-bottom: 60px;
  }

  .top {
    position: relative;
    display: list-item;
    text-align: left;
    padding: 0;
    background-color: #0A7846;
  }

  /* 初始导航栏 隐藏 */
  #nav {
    display: none;
  }

  .top_img {
    height: 40px;
    margin-left: 18px;
    text-align: center;
  }


  .top_img img {
    width: 120px;
  }

  .top_icon {
    /* display: list-item; */
    float: right;
    font-size: 30px;
    position: static;
    color: #000;
  }

  .top_nav {
    width: 100%;
    line-height: 30px;
    flex: 1;
    text-align: center;
    position: absolute;
    top: 30px;
  }

  ul {
    padding: 0;
    align-items: center;
    justify-content: center;
    display: list-item;
    flex-wrap: wrap;
    background: #0058527a;
    margin: 0;
  }

  .li {
    margin: 0 auto;
    width: 100%;
    transition: 0.2s all linear;
  }

  .li a {
    color: black;
    text-decoration: none;
  }

  .li:hover {
    width: 100%;
    // background: coral;
  }


  .appFoot {
    width: 100%;
    height: auto;
    margin: 0 auto;
    display: none;
  }

  .appFoot_left,
  .appFoot_right {
    width: 50%;
    margin: 0;
    padding: 0;
  }

  .appFoot a {
    color: black;
    text-decoration: none;
  }

  .appFoot h5 {
    font-size: 1rem;
    padding: 10px;
  }

  .appFoot h6 {
    width: 100%;
    font-size: 1rem;
    position: absolute;
    text-align: center;
    color: black;
    margin-top: 350px;
  }

  .mappFoot {
    display: block;
    background-color: #0A7846;
    padding: 10px;
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: #fff;
  }

}



.dropdown {
  margin: 0 20px;

  .dropdown-title {
    display: inline-block;
    position: relative;
    height: 60px;
    line-height: 60px;
    font-size: 20px;
    color: #fff;
    background-color: #000;
    padding: 0 24px;
    border-radius: 4px;
    cursor: pointer;
  }

  .dropdown-content {
    position: absolute;
    visibility: hidden;
    opacity: 0;
    transition: all 0.6s ease-in-out;

    .dropdown-menu {
      margin-top: 4px;
      // padding: 10px 8px 15px;
      color: white;
      background-color: rgba($color: #000, $alpha: 0.8);
      border-radius: 4px;

      .menuItem {
        // width: 100%; 
        white-space: nowrap;
        padding: 10px 16px;
        font-size: 16px;
        color: white;
        cursor: pointer;
        border-radius: 4px;

        &:hover {
          background-color: #ccc;
        }
      }
    }
  }

  &:hover .dropdown-content {
    visibility: visible;
    opacity: 1;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue